import React, { useMemo, useRef } from 'react'
import { useParamsInt } from '../../../../shared/hooks/location'
import { IconTable } from '../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { useLoad } from '../../../../shared/hooks/load'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { useApiListReportGeneralCourse } from '../../../../api-new/state/analytics'
import { Menu, MenuExport } from '../../../../shared/menu/menu'
import { useApiFormNode } from '../../../../api-new/state/content'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnDuration, ColumnText } from '../../../../shared/table-builder/table-columns'
import { externalLearnersText, useExternalLearnerSummary } from '../../org/external-learners'

export const AnalyticCourseGeneral = () => {
  const { nodeID } = useParamsInt()

  const apiFormNode = useApiFormNode()
  const apiListReportGeneralCourse = useApiListReportGeneralCourse()

  useLoad(() => apiFormNode.get(nodeID), [])

  const externalLearners = externalLearnersText(useExternalLearnerSummary(nodeID), { course: true })

  const handleReady = () => apiListReportGeneralCourse.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListReportGeneralCourse.init()

  const title = useMemo(() => `Analytics General - ${apiFormNode.form.name}`, [apiFormNode.form])

  const tableRef = useRef()
  const handleExportCsv = () => tableRef.current.exportCsv('analytics')

  const HeaderMenu = () =>
    <Menu>
      <MenuExport onClick={handleExportCsv} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconTable} text="analytics general">
        <CardFullHeightScrollY title={title} subtitle={externalLearners} HeaderMenu={HeaderMenu}>
          <TableAgClient ref={tableRef} apiList={apiListReportGeneralCourse} sortDesc onReady={handleReady} onDestoryed={handleDestroyed} pollInterval={5000}>
            <ColumnText field="sessionID" />

            <ColumnDateTime field="sessionStartOn" />
            <ColumnDateTime field="sessionEndOn" />
            <ColumnText field="sessionDuration" />

            <ColumnText field="stepDuration" />

            <ColumnText field="courseID" />
            <ColumnText field="courseName" />

            <ColumnText field="email" />
            <ColumnText field="firstName" />
            <ColumnText field="lastName" />

            <ColumnText field="stepName" header="Step" />
            <ColumnText field="objectives" />
            <ColumnText field="objectivesCompleted" />
            <ColumnText field="attachments" />
            <ColumnText field="attachmentsCompleted" header="Attachments Viewed" />

            <ColumnText field="os" />
            <ColumnText field="platform" />
            <ColumnText field="appVersion" />
            <ColumnText field="deviceModel" />
            <ColumnText field="deviceType" />
            <ColumnText field="vrDeviceModel" />
            <ColumnText field="vrDeviceName" />
            <ColumnText field="vrDevicePresent" />
            <ColumnText field="vrDeviceTrackingOriginMode" />
            <ColumnText field="vrDeviceTrackingSpaceType" />
            <ColumnText field="vrDeviceRefreshRate" />
            <ColumnText field="graphicsCard" />
            <ColumnText field="graphicsCardMemorySize" />
            <ColumnText field="graphicsCardVendor" />
            <ColumnText field="processor" />
            <ColumnText field="processorCount" />
            <ColumnText field="processorFrequency" />
            <ColumnText field="systemMemorySize" />
            <ColumnText field="isMultiPlayer" />
            <ColumnText field="locationCountry" />
            <ColumnText field="locationRegion" />
            <ColumnText field="locationCity" />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
